import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

export function CertificatesList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/certificates").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-white rounded-2xl border-2 border-slate-200 p-4 space-y-2 rise rise-1" data-testid="certificates-list">
      <div className="flex items-center gap-2 font-display text-xl font-bold uppercase"><Award className="w-6 h-6 text-amber-500" /> Mes certificats</div>
      {items.length === 0 ? (
        <p className="text-sm text-slate-600" data-testid="certificates-empty">Passez au niveau supérieur pour obtenir votre premier certificat.</p>
      ) : items.map((c) => (
        <Link key={c.id} to={`/certificat/${c.id}`} data-testid={`certificate-item-${c.id}`} className="flex items-center gap-3 rounded-xl bg-amber-50 border-2 border-amber-200 hover:border-amber-400 p-3 transition-colors">
          <Award className="w-6 h-6 text-amber-600" />
          <span className="flex-1 font-bold">{c.level_from_label} → {c.level_to_label}</span>
          <span className="text-xs text-slate-500">{new Date(c.issued_at).toLocaleDateString("fr-FR")}</span>
          <ChevronRight className="w-5 h-5 text-slate-400" />
        </Link>
      ))}
    </div>
  );
}
